/***
 * 创建人：
 * 时间：2020-09-06
 * 描述：模型可视化编辑：模型新增、编辑、删除、可视化查看、发布；概念、属性、关系管理
 *       对于已发布版本，编辑、删除（概念、属性、概念关系）等操作会生成新版本；新增、重命名、排序、复制、查看等操作不会生成新版本；
 * 更新说明:
 */
import { Component, OnInit, ViewChild } from '@angular/core';
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../../kms.service';
import { ModelAddComponent } from '../model-add/model-add.component';
import { ModelEditComponent } from '../model-edit/model-edit.component';
import { VersionEditComponent } from '../version-edit/version-edit.component';
declare var $;
@Component({
  selector: 'app-model-visual',
  templateUrl: './model-visual.component.html',
  styleUrls: ['./model-visual.component.css']
})
export class ModelVisualComponent implements OnInit {
  // 删除确认组件
  @ViewChild("trim") trim: SwMassageConfirmComponent;

  //是否展示数据模型
  showLeft: boolean = true
  // 当前登录用户所属组织
  orgId:string = '';
  // 当前登录用户绑定的角色
  userRole:string = '';
  // 搜索关键字：模型名称
  modelName: string = '';
  // 左侧模型树数据
  modelTreeDatas:any = [];
  copyModelTreeDatas:any = [];
  // 是否正在加载左侧模型树
  isLoadingAllModels = false;
  // 当前选中的模型
  selectedModel:any = null;
  // 当前选中的模型版本
  selectedVersion:any = null
  // 当前查看的模型版本是否为历史版本
  isRecordVersion = true;
  // 操作模块 0 概念 ；1 元数据；2：概念关系
  module = 0;
  // 具体操作 addConcept 添加概念
  state = 'addConcept';
  // 选中的概念节点信息
  selectConcept:any = {};
  // 选中的属性节点信息
  selectAttr:any = {};
  selectField:any = {};
  // 选中的关系数据
  selectRel:any = {};
  // 概念、属性发生变化时刷新model-show模型可视化组件
  refreshState = null;
  // 关系发生变化时刷新关系查询组件
  refreshState1 = null;
  constructor(
    private jwt: SwJwtService,
    private box: SwMassageBoxService,  //消息提示框
    private kmsService: KmsService,   //请求服务
    private create: SwCreateModalComponentService
  ) { }

  ngOnInit() {
    // 获取用户所属组织id及用户角色信息
    this.orgId = this.jwt.getToken('orgId');
    this.userRole = this.jwt.getToken('userRole');
    // 查询数据模型树结构数据
    this.querymodelTreeDatas(false,false);
    // 阻止页面的右键弹出快捷菜单事件
    document.getElementById('modelVisualPage').oncontextmenu = function (event){
      return false;
    }
  }

  // 查询左侧数据模型树
  // onlyRefreshLeftTree: true 只刷新左侧模型树；false 同时刷新左侧模型树和模型可视化组件
  // onlyRefreshLeftTree为false时，showNewVersion 为 true,则默认展示生成的新模型版本；为false,默认展示第一个模型下的最新版本
  querymodelTreeDatas(onlyRefreshLeftTree,showNewVersion?) {
    this.isLoadingAllModels = true;
    let params = {
      'isPublic': this.userRole == '超级管理员' ? null : 0,  // 是否查询公开的数据模型，主要用于知识库管理员创建数据模型时，选择模板进行调用
      'isAllowed': 0,  // 是否只查询审核通过的版本： 0 否 1 是
      'isDelete': 0,   // 是否删除： 0 是 1 否
      'orgId': this.userRole == '超级管理员' ? '' : this.orgId,
    }
    this.kmsService.queryUsableModelList(params).subscribe(
      data => {
        this.isLoadingAllModels = false;
        if (data.code == '200') {
          if (data.data && data.data.length > 0) {
            let res = data.data ? data.data : [];
            this.copyModelTreeDatas = res;
            this.queryModelByName();
            // 重新加载模型可视化组件
            if(!onlyRefreshLeftTree){
              if(showNewVersion){
                // 加载selectedModel下的最后一个版本
                this.loadLastVersion(this.selectedModel);
              }else{
                // 默认加载第一个模型下的最后一个版本
                if(res.length>0){
                  let models = this.copyModelTreeDatas.filter(el => el.parentId === 'root');
                  if(models.length>0){
                    this.loadLastVersion(models[0]);
                  }else{
                    this.selectedModel = {};
                    this.selectedVersion = {};
                  }
                }else{
                  this.selectedModel = {};
                  this.selectedVersion = {};
                }
              }
            }
          }
        } else {
          this.box.waring(data.msg);
        }
      }
    )
  }

  // 加载某个模型下的最后一个版本
  loadLastVersion(selectModel){
    this.selectedModel = selectModel;
    let versions = this.copyModelTreeDatas.filter(el => el.parentId === selectModel.id);
    if(versions.length>0){
      this.selectedVersion = versions[versions.length - 1];
      this.isRecordVersion = false;
      this.selectedVersion['modelName'] = selectModel.text;
      // 每次切换查看的模型后，将右侧的操作恢复到默认状态：展示概念操作模块-新增概念
      if(this.module === 0){
        this.state = 'addConcept';
      }
      if(this.module === 1){
        this.state = 'addAttr';
      }
    }else{
      this.selectedModel = {};
      this.selectedVersion = {};
    }
  }

  //enter键触发查询模型
  enterSearch(event) {
    if (event.keyCode == '13') {
      this.queryModelByName();
    }
  }

  // 重置模型
  resetModel(){
    this.modelName = '';
    this.queryModelByName();
  }

  // 根据模型名称筛选模型信息
  queryModelByName(){
    let name = $.trim(this.modelName);
    if(name){
      let models = this.copyModelTreeDatas.filter(el => el.text.indexOf(name)>-1 && el.parentId === 'root');
      if(models.length>0){
        let versions = [];
        models.forEach(element => {
          let items = this.copyModelTreeDatas.filter(el => el.parentId == element.id);
          versions = versions.concat(items);
        });
        this.modelTreeDatas = models.concat(versions);
      }else{
        this.modelTreeDatas = [];
      }
    }else{
      this.modelTreeDatas = JSON.parse(JSON.stringify(this.copyModelTreeDatas));
    }
  }

  // 点击选中左侧的某个模型或模型版本
  handleVotedClick(event) {
    // 根据当前点击的节点的父id是否为根节点判断当前点击的是模型名称还是版本号
    let state = !event.parent || event.parent == 'root';
    // 获取操作类型：鼠标左键或右键
    let button = this.jwt.getToken('nodeClickButton');
    setTimeout(() => {
      let offset = $('.modelVisualPage').offset();
      let offset1 = $('#modelTree .tree-selected').offset();
      let left = offset1.left - offset.left + (state ? 150 : 100);
      let top = null;
      let windowH = $(window).height();
      let elH = 28*(state ? 2 : 3);
      // 判断菜单显示后是否会超出页面显示高度
      if(offset1.top + elH >= windowH){
        top = offset1.top - offset.top - (offset1.top + elH - windowH) - 10;
      }else{
        top = offset1.top - offset.top;
      }
      // 当前点击的是模型名称
      if(state){
        if(this.userRole == '知识库管理员'){
          // 右键操作
          if(button == '2'){
            $('.modelMenu').css({'display':'block','left':left,'top':top});
            $('.modelVersionMenu').css('display','none');
          }
          // 左键操作
          else if(button == '0'){
            $('.modelMenu').css('display','none');
            $('.modelVersionMenu').css('display','none');
          }
        }
        this.selectedModel = event.data;
      }
      // 当前点击的是模型版本号
      else{
        if(this.userRole == '知识库管理员'){
          // 右键操作
          if(button == '2'){
            $('.modelVersionMenu').css({'display':'block','left':left,'top':top});
            $('.modelMenu').css('display','none');
          }
          // 左键操作
          else if(button == '0'){
            $('.modelMenu').css('display','none');
            $('.modelVersionMenu').css('display','none');
          }
        }
        // 展示模型可视化组件
        if(!this.selectedVersion || this.selectedVersion.id != event.key){
          // 根据模型版本获取模型信息
          let parent = this.copyModelTreeDatas.filter(item => item.id == event.parent)[0];
          this.selectedModel = parent;
          this.selectedVersion = event.data;
          this.selectedVersion['modelName'] = parent.text;
          // 判断当前查看的版本是否为历史版本
          let items = this.copyModelTreeDatas.filter(item => item.pid == event.parent);
          this.isRecordVersion = items[items.length - 1].id != event.key;
          // 每次切换查看的模型后，将右侧的操作恢复到默认状态：展示概念操作模块-新增概念
          this.module = 0;
          this.state = 'addConcept';
        }
      }
    },0);
  }
  
  // 模型创建方法
  handleAddClick(){
    this.create.createModal(ModelAddComponent, {}, this.querymodelTreeDatas.bind(this,true));
  }

  // 模型右键菜单功能
  modelToolbarClick(type){
    // 编辑模型
    if(type == 'editModel'){
      $('.modelMenu').css('display','none');
      let datas = {
        upOrAdd: "Edit",
        selectedData: this.selectedModel
      }
      this.create.createModal(ModelEditComponent, datas, this.querymodelTreeDatas.bind(this,true));
    }
    // 删除模型
    else if(type == 'deleteModel'){
      $('.modelMenu').css('display','none');
      // 判断当前模型下是否存在历史版本，存在则不允许删除
      let publishedVers = this.copyModelTreeDatas.filter(el => el.parentId == this.selectedModel.id && el.approvalStatus === 1);
      if (publishedVers.length > 0) {
        this.box.danger('当前模型存在已发布的版本，不允许删除！');
      } else {
        // 删除模型
        this.trim.openCLick("确认删除选中的模型吗？", (res) => {
          if (res) {
            let ids = [this.selectedModel.id]
            this.kmsService.deleteModelById(ids).subscribe(
              result => {
                if (result.code == '200') {
                  this.box.success('删除成功！');
                  this.querymodelTreeDatas(false,false);
                } else {
                  this.box.waring(result.msg);
                }
              }
            );
          }
        })
      }
    }
    // 编辑模型版本
    else if(type == 'editVersion'){
      $('.modelVersionMenu').css('display','none');
      let items = this.copyModelTreeDatas.filter(el => el.id == this.selectedVersion.parentId);
      let selectedData:any = this.selectedVersion;
      selectedData['modelName'] = items[0].name;
      let datas = {
        upOrAdd: "Edit",
        selectedData: selectedData
      }
      this.create.createModal(VersionEditComponent, datas, this.querymodelTreeDatas.bind(this,true));
    }
    // 删除模型版本
    else if(type == 'deleteVersion'){
      $('.modelVersionMenu').css('display','none');
      this.trim.openCLick("确认删除选中的模型版本吗？", (res) => {
        if (res) {
          let ids = [this.selectedVersion.id]
          this.kmsService.deleteRecordInfo(ids).subscribe(
            result => {
              if (result.code == '200') {
                this.box.success('删除成功！');
                this.querymodelTreeDatas(false,false);
              } else {
                this.box.waring(result.msg);
              }
            }
          );
        }
      })
    }
    // 发布模型版本
    else if(type == 'publishVersion'){
      $('.modelVersionMenu').css('display','none');
      this.trim.openCLick("确认发布选中的模型版本吗？", (res) => {
        if (res) {
          let value:any = {
            modelVerId: this.selectedVersion.id,
            approvalStatus: 1,
          };
          this.kmsService.updateRecordInfo(value).subscribe(
            data => {
              if(data.code == '200'){
                this.box.success('发布成功！');
                this.querymodelTreeDatas(false,true);
              }else{
                this.box.waring(data.msg);
              }
            }
          );
        }
      })
    }
  }

  // 右侧操作模块：概念（编辑、查看、删除、复制、元数据配置、关系配置）、属性（...)功能按钮相关操作
  toolbarBtnClick(event){
    if(event.state != 'deleteRel'){
      this.state = event.state;
    }
    // 编辑、查看、复制概念
    if(event.state == 'editConcept' || event.state == 'conceptView' || event.state == 'copyConcept'){
      this.module = 0;
      this.selectConcept = event.selectConcept;
    }
    // 删除概念
    if(event.state == 'deleteConcept'){
      this.module = 0;
      this.trim.openCLick('删除父概念时，子概念将一并被删除，请确认是否删除当前选中的概念吗？', (data) => {
        if (data) {
          this.kmsService.deleteConceptById(event.selectConcept.primaryKey).subscribe(
            result => {
                if (result.code == 200) {
                  this.box.success('操作成功！');
                  // 若当前模型版本已审核通过
                  if(this.selectedVersion.approvalStatus){
                    // 刷新左侧模型树、model-show模型可视化组件（显示生成的版本数据）
                    this.querymodelTreeDatas(false,true);
                  }else{
                    // 刷新model-show模型可视化组件
                    this.refreshState = new Date().getTime();
                  }
                }
            }
        )
        }
      })
    }
    // 元数据配置
    if(event.state == 'attrConfig'){
      this.module = 1;
      this.state = 'addAttr';
      this.selectConcept = event.selectConcept;
    }
    // 关系配置
    if(event.state == 'relationConfig'){
      this.module = 2;
      this.state = 'relQuery';
      this.selectConcept = event.selectConcept;
    }
    // 从元数据配置返回概念配置页面
    if(event.state == 'toConceptPage'){
      this.module = 0;
      this.state = 'addConcept';
    }
    // 编辑属性、查看属性
    if(event.state == 'editAttr' || event.state == 'attrView'){
      this.module = 1;
      this.selectAttr = event.selectAttr;
    }
    // 新增子属性
    if(event.state == 'addField'){
      this.module = 1;
      this.selectAttr = event.selectAttr;
      this.selectField = {primaryKey:''};
    }
    // 编辑子属性
    if(event.state == 'editField' || event.state == 'fieldView'){
      this.module = 1;
      this.selectAttr = event.selectAttr;
      this.selectField = event.selectField;
    }
    // 删除属性
    if(event.state == 'deleteAttr'){
      this.module = 1;
      this.trim.openCLick('删除属性时，子属性将一并被删除，请确认是否删除当前选中的属性吗？', (data) => {
        if (data) {
          this.kmsService.deleteOntologyById([event.selectAttr.primaryKey]).subscribe(
            result => {
              if (result.code == 200) {
                this.box.success('操作成功！');
                // 若当前模型版本已审核通过
                if(this.selectedVersion.approvalStatus){
                  // 刷新左侧模型树、model-show模型可视化组件（显示生成的版本数据）
                  this.querymodelTreeDatas(false,true);
                }else{
                  // 刷新model-show模型可视化组件
                  this.refreshState = new Date().getTime();
                }
              }
            }
          )
        }
      })
    }
    // 编辑、查看概念关系
    if(event.state == 'editRel' || event.state == 'relView'){
      this.module = 2;
      this.selectRel = event.selectRel;
    }
    // 删除关系
    if(event.state == 'deleteRel'){
      this.trim.openCLick('是否确认删除当前选中的关系？', (data) => {
        if (data) {
          this.kmsService.deleteConceptRelationById([event.selectRel.id]).subscribe(
            result => {
              if (result.code == 200) {
                this.box.success('操作成功！');
                // 若当前模型版本已审核通过
                if(this.selectedVersion.approvalStatus){
                  // 刷新左侧模型树、model-show模型可视化组件（显示生成的版本数据）
                  this.querymodelTreeDatas(false,true);
                  this.refreshState1 = new Date().getTime();
                }else{
                  // 刷新关系查询组件
                  this.refreshState1 = new Date().getTime();
                }
              }
            }
          )
        }
      })
    }
  }

  // 主页面：概念（新增、排序）、属性（新增、排序)、概念关系（新增、排序)功能按钮相关操作
  toolbarClick(state){
    this.state = state;
    // 新增概念、概念排序
    if(state == 'addConcept' || state == 'conceptSort'){
      this.module = 0;
      this.selectConcept = {primaryKey:''};
    }
    // 新增属性、属性排序
    if(state == 'addAttr' || state == 'attrSort'){
      this.module = 1;
      this.selectAttr = {primaryKey:''};
    }
    // 新增概念关系、概念关系排序
    if(state == 'addRel' || state == 'relSort'){
      this.module = 2;
      this.selectRel = {id:null};
    }
  }

  // 保存概念信息操作成功回调
  // event: true 重命名操作；
  conceptSaveEmit(event){
    // 当前操作为编辑概念时，需根据当前模型的版本的审核状态判断是否会生成新版本，是否需要刷新左侧模型树
    if(this.state == 'editConcept' && !event){
      // 若当前模型版本已审核通过
      if(this.selectedVersion.approvalStatus){
        // 刷新左侧模型树、model-show模型可视化组件（显示生成的版本数据）
        this.querymodelTreeDatas(false,true);
      }else{
        // 刷新model-show模型可视化组件
        this.refreshState = new Date().getTime();
      }
    }else{
      // model-show模型可视化组件
      this.refreshState = new Date().getTime();
    }
    // 当前操作不是修改排序号时，需要关闭当前页面（修改排序号时，不需要关闭当前页面，可多次修改）
    if(this.state != 'conceptSort'){
      this.state = '';
    }
  }

  // 取消保存概念信息操作成功回调
  conceptCancelEmit(event){
    this.state = '';
  }

  // 保存属性信息操作成功回调
  // event: true 重命名操作；
  attrSaveEmit(event){
    // 当前操作为编辑属性时，需根据当前模型的版本的审核状态判断是否会生成新版本，是否需要刷新左侧模型树
    if((this.state == 'editAttr' || this.state == 'editField') && !event){
      // 若当前模型版本已审核通过
      if(this.selectedVersion.approvalStatus){
        // 刷新左侧模型树、model-show模型可视化组件（显示生成的版本数据）
        this.querymodelTreeDatas(false,true);
      }else{
        // 刷新model-show模型可视化组件
        this.refreshState = new Date().getTime();
      }
    }else{
      // model-show模型可视化组件
      this.refreshState = new Date().getTime();
    }
    // 当前操作不是修改排序号时，需要关闭当前页面（修改排序号时，不需要关闭当前页面，可多次修改）
    if(this.state != 'attrSort'){
      this.state = '';
    }
  }

  // 取消保存属性信息操作成功回调
  attrCancelEmit(event){
    this.state = '';
  }

  // 保存概念关系信息操作成功回调
  // event: true 重命名操作；
  relSaveEmit(event){
    // 当前操作为编辑概念关系时，需根据当前模型的版本的审核状态判断是否会生成新版本，是否需要刷新左侧模型树
    if(this.state == 'editRel' && !event){
      // 若当前模型版本已审核通过
      if(this.selectedVersion.approvalStatus){
        // 刷新左侧模型树、model-show模型可视化组件（显示生成的版本数据）
        this.querymodelTreeDatas(false,true);
      }else{
        // 刷新关系查询组件
        this.refreshState1 = new Date().getTime();
      }
    }else{
      // 刷新关系查询组件
      this.refreshState1 = new Date().getTime();
    }
    this.state = 'relQuery';
  }

  // 取消保存概念关系信息操作成功回调
  relCancelEmit(event){
    this.state = 'relQuery';
  }

  // 关闭菜单
  closeMenu(state){
    if(state){
      $('.modelMenu').css('display','none');
    }else{
      $('.modelVersionMenu').css('display','none');
    }
  }

  // 左侧数据模型切换显示或隐藏
  showStyle(data) {
    this.showLeft = !data;
    $('.modelMenu').css('display','none');
    $('.modelVersionMenu').css('display','none');
  }
}
